var fa = {};
module['exports'] = fa;
fa.title = "Farsi";
fa.name = require("./name");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/fa/index.js
// module id = 1309
// module chunks = 1